<template>
    <base-component>
        <template slot="form" v-if="isAdmin && isKkmAttribute">
            <search-form @onSearch="search" />
        </template>
        <template slot="workArea">
            <b-alert variant="danger" :show="showAlert">
                {{ alert }}
            </b-alert>
            <b-card class="flex-fill flex-shrink-0">
                <b-table :items="attributes" :fields="fields" class="table-borderless" striped small show-empty>
                    <template slot="actions" slot-scope="row">
                        <b-dropdown variant="link">
                            <template slot="button-content">
                                <dots-icon title="" />
                            </template>
                            <b-dd-item @click.stop="openEditAttributeModal(row)">{{ $t('general.edit') }}</b-dd-item >
                            <b-dd-item v-if="isKkmAttribute" @click.stop="useDefault(row)">{{ $t('general.useDefaultValue') }}</b-dd-item> 
                        </b-dropdown>
                    </template>
                    <template slot="empty">
                        <div class="text-center">
                            {{ $t('general.noData') }}
                        </div>
                    </template>
                </b-table>
                <b-modal ref="editAttributeModal" :title="$t('menu.editAttribute')" hide-footer lazy>
                    <attribute-edit-form 
                        :attribute="clickedAttribute" 
                        :refresh="fetchData"
                        :service="service"
                        :kkmId="getKkmId()" />
                </b-modal>
            </b-card>
        </template>
    </base-component>
</template>

<script>
/* eslint-disable */

import AppData from '@/utils/appdata';
import AttributesService from '@/services/AttributesService';

const AttributeEditForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/attributes/AttributeEditForm.vue');
const SearchForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/attributes/SearchForm.vue');

//todo: Bad design for this component

export default {
    name: 'Attributes',
    mixins: [AppData],
    components: {
        AttributeEditForm,
        SearchForm
    },
    created() {
        this.fetchData();
    },
    data() {
        return {
            showAlert: false,
            alert: '',
            attributes: [],
            clickedAttribute: null,
            service: null,
            currentKkmId: null
        }
    },
    created() {
        const urls = {
            baseUrl: this.$appConfig.apiUrls.baseUrl,
            ...this.$appConfig.apiUrls.attributes
        };

        this.service = new AttributesService(
            urls,
            (url, data, method) => this.$request.sendRequestAsync(this, url, data, method)
        );
    },
    async mounted() {
        if (this.isKkmAttribute) {
            if (!this.isAdmin)
                await this.fetchData();
        } else if (this.isAdmin) {
            await this.fetchData();
        }
    },
    computed: {
        fields() {
            const columns = [
                { key: 'code', label: this.$t('attribute.code'), sortable: true },
                { key: 'value', label: this.$t('attribute.value'), sortable: true },
                { key: 'comment', label: this.$t('attribute.comment') },
            ];

            if (this.isAdmin || this.isOperator)
                columns.push({ key: 'actions', label: this.$t('general.actions') });

            return columns;
        },
        isKkmAttribute() {
            return this.$route.meta.isKkmAttribute;
        }
    },
    methods: {
        async fetchData(kkmId) {
            this.hideAlert();
            
            this.attributes = [];

            if (kkmId == null && this.isKkmAttribute)
                kkmId = this.getKkmId();

            const request = kkmId != null 
                ? { kkmId }
                : {};
            
            try {
                this.attributes = await this.service.getAttributes(request);
            } catch (error) {
                this.displayAlert(error);
            }
        },
        hideAlert() {
            this.showAlert = false;
            this.alert = '';
        },
        displayAlert(errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`);
            this.showAlert = true;
        },
        openEditAttributeModal(row) {
            this.clickedAttribute = row.item;
            this.$refs.editAttributeModal.show();
        },
        async useDefault(row) {
            if (this.isKkmAttribute){
                try {
                    await this.service.setDefaultValue({
                        kkmId: this.getKkmId(),
                        code: row.item.code
                    });
                }
                catch(error) {
                    this.displayAlert(error);
                }

                await this.fetchData(this.getKkmId());
            }
        },
        async search(kkmId) {
            this.kkmId = kkmId;

            await this.fetchData(kkmId);
        },
        getKkmId() {
            return this.kkmId != null 
                ? this.kkmId 
                : this.$route.params.kkmId;
        }
    }
}
</script>
